export const getLogsData = (page) => ({
    method: "get",
    url: `reports/logs?page=${page}`,
  })

  export const getTransactionsData = (page) => ({
    method: "get",
    url: `reports/transactions?page=${page}`,
  })